import { ChevronLeftIcon, EnterIcon } from "@radix-ui/react-icons";
import { Card, Flex, Button, Spinner } from "@radix-ui/themes";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import RadioGroupComponent from "../../components/inputs/RadioGroup/RadioGroupComponent";
import TextFieldComponent from "../../components/inputs/Textfield/TextfieldComponent";
import { useGetCurrentAcademicYearQuery } from "../../hooks/useGetCurrentAcademicYearQuery";
import { routes } from "../../routes";
import { updateTeacherEvaluationCriteria } from "../../services/school/teacher/teacherEvaluationCriteria";
import { TeacherEvaluationCriteriaType } from "../../types/TeacherEvaluation";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { yupResolver } from "@hookform/resolvers/yup";
import { TeacherEvaluationFormValidation } from "./TeacherEvaluationFormValidation";
import { useAppDispatch } from "../../hooks/hooks";
import { resetTeacherEvaluationCriteriaData } from "../../redux/slices/school/teacherEvaluationCriteria";

export const UpdateTeacherEvaluationCriteria = () => {
  const teacherEvaluationCriteriaFormData = useSelector((state: RootState) => state.teacherEvaluationCriteria);
  const dispatch = useAppDispatch();
  const mutation = useMutation({ mutationFn: updateTeacherEvaluationCriteria, mutationKey: 'updateTeacherEvaluationCriteria' });
  const { data: currentAcademicYear, isLoading: isLoadingCurrentAcademicYear, isError: errorCurrentAcademicYear } = useGetCurrentAcademicYearQuery();
  const navigate = useNavigate();
  const defaultValues: TeacherEvaluationCriteriaType= teacherEvaluationCriteriaFormData;
  const { control, handleSubmit, formState: { errors }, getValues,setValue } = useForm<TeacherEvaluationCriteriaType>
  (
    {
     resolver: yupResolver(TeacherEvaluationFormValidation),
      defaultValues: defaultValues,
      mode: 'onBlur',
      reValidateMode: 'onBlur',
      shouldUseNativeValidation: false,
    }
  );
  const onSubmit = handleSubmit(async (data) => {
    try {
      data.idAcademicYear = currentAcademicYear?.id!;
      const result = await mutation.mutateAsync(data);
      if (result) {
        toast.success("Critério de avaliação actualizado!");
        navigate(routes.teacherEvaluationCriterias);
      }
    } catch (err: any) {
      toast.error(`${mutation.error ?? err?.message}`);
    }
  });
  const handleBack = () => {
    dispatch(resetTeacherEvaluationCriteriaData());
    navigate(routes.teacherEvaluationCriterias);
  }
  return (
    <form onSubmit={onSubmit} noValidate>
    <Card size='1'>
      <Flex direction='column' gap='4'>
        <TextFieldComponent name="description" label="Descrição" control={control} errors={errors} fieldProps={{ placeholder: 'Descrição' }} required={true}/>
          <RadioGroupComponent name="isForStudent" label="Para estudantes?" control={control} errors={errors} style={{ width: '100%' }}
            options={[
              { value: "true", label: "Sim" }
              , { value: "false", label: "Não" }]}
            fieldProps={{
              style: { display: 'flex', flexDirection: 'row', gap: '16px' }
            }}
          />
        <Flex direction='row' gap='4' style={{ alignSelf: 'end' }}>
          <Button color='red' onClick={handleBack} disabled={mutation.isLoading}>
            <ChevronLeftIcon /> voltar
          </Button>
          <Button type="submit" disabled={mutation.isLoading} variant='surface'  >
            {mutation.isLoading ? <Spinner loading> <EnterIcon /></Spinner> : <EnterIcon />}
            Registar
          </Button>
        </Flex>

      </Flex>
    </Card>
    
  </form>
  )
}
